import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="navbar-container">
      {/* Logo Section - Top */}
      <div className="navbar-logo">
        <Link to="/" className="logo-link">
          <img 
            src="/assets/logo.png" 
            alt="Peak Autism Center Logo" 
            style={{ 
              height: '150px',
              width: 'auto'
            }} 
          />
          <span className="visually-hidden">Peak Autism Center</span>
        </Link>
      </div>

      {/* Desktop Navigation - Centered below logo */}
      <nav className="desktop-nav" role="navigation">
        <ul className="nav-list">
          <li className="nav-item">
            <Link to="/" className="nav-link">
              <span>Home</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link">
              <span>About</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/mission" className="nav-link">
              <span>Our Mission</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/services" className="nav-link">
              <span>Services</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link">
              <span>Contact</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/referal" className="nav-link">
              <span>Referral</span>
            </Link>
          </li>
        </ul>
      </nav>

      {/* Mobile Menu Button - Top right */}
      <div className="mobile-menu-button" style={{ 
        display: 'none',
        position: 'absolute',
        top: '1rem',
        right: '1rem'
      }}>
        <button
          className="slds-button slds-button_icon slds-button_icon-small"
          onClick={toggleMenu}
          aria-label="Toggle menu"
          style={{ color: 'white' }}
        >
          <svg className="slds-button__icon" aria-hidden="true" style={{ width: '1rem', height: '1rem' }}>
            <path d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z" fill="currentColor"/>
          </svg>
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="mobile-menu-dropdown">
          <ul className="mobile-menu-list">
            <li className="mobile-menu-item">
              <Link to="/" className="mobile-menu-link" onClick={closeMenu}>
                <span>Home</span>
              </Link>
            </li>
            <li className="mobile-menu-item">
              <Link to="/about" className="mobile-menu-link" onClick={closeMenu}>
                <span>About</span>
              </Link>
            </li>
            <li className="mobile-menu-item">
              <Link to="/mission" className="mobile-menu-link" onClick={closeMenu}>
                <span>Our Mission</span>
              </Link>
            </li>
            <li className="mobile-menu-item">
              <Link to="/services" className="mobile-menu-link" onClick={closeMenu}>
                <span>Services</span>
              </Link>
            </li>
            <li className="mobile-menu-item">
              <Link to="/contact" className="mobile-menu-link" onClick={closeMenu}>
                <span>Contact</span>
              </Link>
            </li>
            <li className="mobile-menu-item">
              <Link to="/referal" className="mobile-menu-link" onClick={closeMenu}>
                <span>Referral</span>
              </Link>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default Navbar; 